



































































































import Vue, { PropType, VueConstructor } from "vue";
import {
  ExchangeConfigurationForm,
  createExchangeConfigurationForm,
} from "@/models/providerAccount";
import validationMixin, {
  ValidatableForm,
} from "@/components/mixins/validationMixin";

type ValidationRule = (value: string) => true | string;

interface ValidationMixin extends Vue {
  valid: boolean;
  required: ValidationRule;
  url: ValidationRule;
  validMail: ValidationRule;
}

const exchangeVersionOptions = [
  { value: "Exchange2007_SP1", label: "Exchange 2007 SP1" },
  { value: "Exchange2010", label: "Exchange 2010" },
  { value: "Exchange2010_SP1", label: "Exchange 2010 SP1" },
  { value: "Exchange2010_SP2", label: "Exchange 2010 SP2" },
  { value: "Exchange2013", label: "Exchange 2013" },
  { value: "Exchange2013_SP1", label: "Exchange 2013 SP1" },
  { value: "Exchange2015", label: "Exchange 2015" },
  { value: "Exchange2016", label: "Exchange 2016" },
  { value: "V2015_10_05", label: "Exchange 2015 10 05" },
];

export default (Vue as VueConstructor<ValidationMixin>).extend({
  name: "ExchangeConfigurationDialog",
  mixins: [validationMixin],
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    initialConfig: {
      type: Object as PropType<ExchangeConfigurationForm>,
      default: createExchangeConfigurationForm,
    },
    callback: {
      type: Function as PropType<
        (config: ExchangeConfigurationForm) => Promise<any> | void
      >,
      required: false,
    },
  },
  data() {
    return {
      exchangeDialogForm: {
        ...this.initialConfig,
      } as ExchangeConfigurationForm,
      exchangeVersionOptions,
      showAdvanced: false,
    };
  },
  computed: {
    dialogOpen: {
      get(): boolean {
        return this.value;
      },
      set(open: boolean) {
        if (!open) {
          this.onCancel();
        }
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(open: boolean) {
        if (open) {
          this.resetExchangeDialogForm();
        }
      },
    },
    initialConfig: {
      deep: true,
      handler() {
        if (!this.value) {
          this.resetExchangeDialogForm();
        }
      },
    },
  },
  methods: {
    resetExchangeDialogForm() {
      this.exchangeDialogForm = {
        ...createExchangeConfigurationForm(),
        ...this.initialConfig,
        exchangeVersion: this.initialConfig.exchangeVersion || "Exchange2016",
      };
      (
        this.$refs.exchangeConfigurationForm as ValidatableForm | undefined
      )?.resetValidation();
    },
    onCancel() {
      this.resetExchangeDialogForm();
      this.$emit("input", false);
      this.$emit("cancel");
    },
    async saveExchangeDialog() {
      if (
        !(this.$refs.exchangeConfigurationForm as ValidatableForm).validate()
      ) {
        return;
      }
      const config = {
        ...this.exchangeDialogForm,
      };
      if (this.callback) {
        await this.callback(config);
      }
      this.$emit("submit", config);
      this.$emit("input", false);
    },
  },
});
